import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getAllInvoice = (state = initialState, action) => requestReducerMaker(cons.GET_ALL_INVOICE, state, action);
export const getInvoice = (state = initialState, action) => requestReducerMaker(cons.GET_INVOICE, state, action);
export const getInvoiceByHashInvoiceNumber = (state = initialState, action) => requestReducerMaker(cons.GET_INVOICE_BY_HASH_INVOICE_NUMBER, state, action);
export const postCreateInvoice = (state = initialState, action) => requestReducerMaker(cons.POST_CREATE_INVOICE, state, action);
